import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatNativeDateModule, MatRippleModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CatAutoComplete } from './cat-autocomplete/catautocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TwoDecimalNumberDirective } from '../theme/directives/twoDecimalNumber.directive';
import { OnlyintegersDirective } from '../theme/directives/integersOnly.directive';
import { OnlyintegersWithSpaceDirective } from '../theme/directives/integersWithSpace.directive';
import { PipesModule } from '../theme/pipes/pipes.module';
import { ToastaModule } from 'ngx-toasta';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SignaturePadModule } from 'angular2-signaturepad';
import { GoogleMapSearch } from './google-map-search/googlemapsearch.component';
import { AgmCoreModule } from '@agm/core';
import { FiltroFechaInteligenteComponent } from './FiltroFechaInteligente/FiltroFecha.component';
import { ComentarioComponent } from './comentario/comentario.component';

import {MomentDateAdapter} from '@angular/material-moment-adapter';
import { CatSelect } from './cat-select/cat-select.component';
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { InputDecimal } from './Directives/inputDecimal.directive';
import { AutoComplete } from './autocomplete/autocomplete.component';
import { NumberPositiveOnlyDirective } from '../theme/directives/numberPositiveOnly.directive';
import { TimePickerComponent } from './timePicker/timePicker';
import { datepickerComponent } from './datepicker/datepicker.component';
import { AgVirtualScrollModule } from 'ag-virtual-scroll';
import { TwoIntTwoDecNumberDirective } from '../theme/directives/twoIntTwoDec.directive';
import { ThreeIntTwoDecNumberDirective } from '../theme/directives/threeIntTwoDec.directive';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SizeDetectorComponent } from './size-detector/size-detector.component';
import { ResizeService } from '../services/resize.service';
import { TwoDecimalEighteenNumberDirective } from '../theme/directives/twoDecimalEighteenNumber.directive';
import { UploadFileComponent } from './UploadFile/UploadFile.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { numberPositiveOnlyMaxLengthDirective } from '../theme/directives/numberPositiveOnlyMaxLength.directive';
import { CRGaugeComponent } from './gauge/gauge.component';
import { DialogOrdenTallerComponent } from '../pages/ModuloTransportes/OrdenDeTaller/Controllers/Dialog/dialogOrdenTaller.component';
import { TableOrdenDeTallerDetalle } from '../pages/ModuloTransportes/OrdenDeTaller/Controllers/Tables/tableOrdenDeTallerDetalle.component';
import { TableArchivosAdjuntos } from '../pages/ModuloTransportes/OrdenDeTaller/Controllers/Tables/tableArchivosAdjuntos.component';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'LL'
},
display: {
    dateInput: 'DD/MM/yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
}
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    DragDropModule,
    PipesModule,
    FontAwesomeModule,
    DragDropModule,
    SignaturePadModule,
    AgVirtualScrollModule,
    ToastaModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCTV20YoFj6qgIvBN15o4UK6dn5rsiXE6w',
      libraries: ['places']
    }),
    [NgxMatTimepickerModule.setLocale('es-MX')],
    CurrencyMaskModule,
    NgxDropzoneModule,
  ],
  exports: [
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    ContentHeaderComponent,
    BreadcrumbComponent,
    CatAutoComplete,   
    OnlyintegersDirective,
    OnlyintegersWithSpaceDirective,
    TwoDecimalNumberDirective,
    TwoDecimalEighteenNumberDirective,
    TwoIntTwoDecNumberDirective,
    ThreeIntTwoDecNumberDirective,
    FontAwesomeModule,
    SignaturePadModule,
    AgVirtualScrollModule,
    DragDropModule,
    PipesModule,//2021-08-25 (aaangeles)
    ToastaModule, // 2021-08-15 (aaangeles)
    GoogleMapSearch,
    FiltroFechaInteligenteComponent, //2021-08-18 (aaangeles)
    CatSelect,
    [NgxMatTimepickerModule.setLocale('es-MX')],
    InputDecimal,
    ComentarioComponent,
    AutoComplete,
    NumberPositiveOnlyDirective,
    numberPositiveOnlyMaxLengthDirective,
    TimePickerComponent,
    datepickerComponent,
    CurrencyMaskModule,
    SizeDetectorComponent,
    UploadFileComponent,
    NgxDropzoneModule,
    CRGaugeComponent,
    DialogOrdenTallerComponent,
    TableOrdenDeTallerDetalle,
    TableArchivosAdjuntos
  ],
  declarations: [
    ContentHeaderComponent,
    BreadcrumbComponent,
    CatAutoComplete,
    OnlyintegersDirective,
    OnlyintegersWithSpaceDirective,
    TwoDecimalNumberDirective,
    TwoDecimalEighteenNumberDirective,
    TwoIntTwoDecNumberDirective,
    ThreeIntTwoDecNumberDirective,
    FiltroFechaInteligenteComponent, //2021-08-18 (aaangeles)
    ComentarioComponent,
    GoogleMapSearch,
    CatSelect,
    InputDecimal,
  	CatSelect,
    AutoComplete,
    NumberPositiveOnlyDirective,
    numberPositiveOnlyMaxLengthDirective,
    TimePickerComponent,
    datepickerComponent,
    SizeDetectorComponent,
    UploadFileComponent,
    CRGaugeComponent,
    DialogOrdenTallerComponent,
    TableOrdenDeTallerDetalle,
    TableArchivosAdjuntos
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
    ResizeService
  ]
})
export class SharedModule { }
